// ==============================================================================================
//  APPLICATION AUTHORSHIP & RIGHTS NOTICE
//
//  Developed by: Gareth Morgan
//  Brand & Product: BuildMyChecks.co.uk
//  Ownership: Sole author and rights holder
//
//  ----------------------------------------------------------------------------------------------
//  NOTICE:
//  - This application and its related systems were designed, developed, and built solely
//    by Gareth Morgan.
//  - Gareth Morgan retains full authorship, intellectual property, and creative rights to
//    all Build My Checks branding, technology, source code, architecture, and design.
//  - No ownership, license, or implied rights are granted to any third party unless
//    explicitly agreed in writing by Gareth Morgan.
//  - Gareth Morgan is NOT responsible for future maintenance, updates, security patching,
//    or operational upkeep if this application is deployed, copied, or modified without
//    his written consent.
//  - Gareth Morgan reserves the right to:
//        Withdraw or disable access to the application or related services
//        Remove hosted, cloud-based, or linked services under his control
//        Revoke access to Build My Checksrelated assets, code, APIs, or integrations
//
//   2025 Gareth Morgan  BuildMyChecks.co.uk
//  Unauthorized use, alteration, copying, or redistribution without written consent
//  is strictly prohibited.
//
//  ----------------------------------------------------------------------------------------------
//  Build My Checks  ASCII Logo Signature
//  (Symbolic representation of BuildMyChecks.co.uk identity)
//
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................:-==++-.........:-:.............................................
// ...................................-*******:.......=*****+-.........................................
// ...................................=*******+:.....+*******=.........................................
// .........................::........+**********************=.........................................
// .......................-+***+-.:-++***********************=:.......:................................
// .....................-+*************************************+-..=+**+-..............................
// .....................:+*************+=-.............-++***************+:............................
// ......................:+********+=:.....................:=*************=............................
// .......................=******+:...........................-+********+-.............................
// ......................-*****+:...............................-+*****+-..............................
// ................:::::+****+-...................................=*****+..............................
// ...............+-......:=+-........+=.*%=......##:.:::.....:::..-*****=.............................
// ..............=*-*@%%%%@*.........-#*:#@=......@%::@@@*...*@@#...-+++++**++=-.......................
// .............:**-*@*..=@%.=#+..*#=-%#:#@=.=#%#+@%::@%%%-.=@%@#-##:..##:+*****:......................
// ..............-+-*@@%%@%+.+@*..#@==%#:#@==@%-:+@%::@#-@#:%#+%#.+@#.*@+-******=......................
// .................*@*..:#@++@*..#@==%#:#@=+@#...@%::@#.+@%%-=%#..%@#%#:+******+......................
// .................*@%##%@#.-%@%%@@==%#:#@=:#@%#%%%::@#.:#@*.=%#...%@%:=****+-:.......................
// ..................::........::.........:....::.....:....:......:-#@--***+:..........................
// ................:++:+@@@@@*.:@#:.....................#%=......:#%#-.+***+:..........................
// .............-+**+:#@*:.:+%+:@#-=+-...:=+=-....-+=-..#%=.:=-..-++-..+***+:..........................
// .............+***=-@%.......:@@#+#@#.+@#-+%#:+@%++@%:#%+*@#::%#--*-:*****+-.........................
// .............-***=:@%.......:@%:.-%%:%@%%%%%+#@=.....#@@@%:..#%@@%-=**+++++*+.......................
// ..............****-+%@*=+%@*:@%:.-%%.*@*-=*=.*@%==%#:#@+=@%=:++-+@*-+--===:+=.......................
// .................::::=***=:..++..:++..-+**=...:+**+:.=+-.:++:-*#*=::-:+***=::-++:...................
// ....................-****+=............................*#......+*****************=..................
// .....................=*****=.......+##+.:+##=....*+.-#-*#.**:..:+************++*=...................
// .....................+******+-....*%..:.%*.:%+..:%*.=%=*%%*..:--***********+:..-+:..................
// ....................+*********=:%=+%*+%-*%+*%-=#-#%*%@=*#:%*:+****+++****+=...=*****-...............
// ...................=**********+--::.::....::...:..::.:.:-::-:=***+:..=+*+:..:+******-...............
// ....................-******++*******+=-:............-=++****+=+***+:...:...=******+-:...............
// ......................-++-....=+***************************+=+-=****+:...-+******-..................
// ................................=**********************++-:....=******=:+********=..................
// ................................=**********************=......:+*****************+:.................
// ................................+*******=......+*******=........-+=.:=+****+-.-+-...................
// ................................:-=+***-........+******=..............=***+.........................
// .................................................--::...............................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
//
// ==============================================================================================

import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import logo from '../../assets/image/logo_web.png';

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: 20 November 2025</p>

        <div className="prose prose-lg max-w-none space-y-6">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Introduction</h2>
            <p className="text-gray-700 mb-4">
              Build My Checks ("we", "our", "us") is committed to protecting your privacy and personal data. This Privacy Policy explains how we collect, use, store, and protect your information when you use the Build My Checks mobile application ("the App").
            </p>
            <p className="text-gray-700">
              We operate as a sole trader business in the United Kingdom and comply with the UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Information We Collect</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-3">2.1 Account Information</h3>
            <p className="text-gray-700 mb-4">When you register and use the App, we collect:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li>Name</li>
              <li>Email address</li>
              <li>User role and permissions</li>
              <li>Authentication credentials (passwords are securely hashed and never stored in plain text)</li>
            </ul>
            <p className="text-gray-700 mb-4">Authentication is handled securely using Firebase Authentication.</p>

            <h3 className="text-xl font-semibold text-gray-900 mb-3">2.2 Inspection and App Data</h3>
            <p className="text-gray-700 mb-4">The App is designed to record inspections and checks. We collect:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li>Inspection forms, checklists, and responses</li>
              <li>Photos and files uploaded during inspections</li>
              <li>Signatures where applicable</li>
              <li>Timestamps related to inspections</li>
              <li>Location data when location services are enabled</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-900 mb-3">2.3 Location Data</h3>
            <p className="text-gray-700 mb-4">
              If you grant permission, the App may collect precise location data to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li>Record where inspections take place</li>
              <li>Support location-based inspection features</li>
            </ul>
            <p className="text-gray-700 mb-4">Location access is optional and can be disabled in your device settings.</p>

            <h3 className="text-xl font-semibold text-gray-900 mb-3">2.4 Usage and Diagnostic Data</h3>
            <p className="text-gray-700 mb-4">We may collect limited technical data to ensure the App functions correctly, including:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Device type and operating system</li>
              <li>App version</li>
              <li>Error logs and crash reports</li>
              <li>Performance diagnostics</li>
            </ul>
            <p className="text-gray-700">This data is used solely to maintain and improve the App.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Local Device Storage</h2>
            <p className="text-gray-700 mb-4">The App uses local device storage to support core functionality, including:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Temporary storage of incomplete inspections</li>
              <li>Offline data while completing checks</li>
              <li>Session authentication tokens</li>
              <li>App preferences</li>
            </ul>
            <p className="text-gray-700">Temporary data is removed once inspections are completed, synchronised, or the App is uninstalled.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. How We Use Your Information</h2>
            <p className="text-gray-700 mb-4">We use your information to:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Provide and operate the App</li>
              <li>Authenticate users and manage accounts</li>
              <li>Store and sync inspection data</li>
              <li>Enable photo and file uploads</li>
              <li>Improve app performance and reliability</li>
              <li>Detect and prevent misuse or security issues</li>
              <li>Comply with legal and regulatory obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Legal Basis for Processing (UK GDPR)</h2>
            <p className="text-gray-700 mb-4">We process personal data under the following legal bases:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Contract</strong> – to provide the App and its features</li>
              <li><strong>Legitimate interests</strong> – to maintain security, prevent abuse, and improve the App</li>
              <li><strong>Consent</strong> – for optional features such as location access</li>
              <li><strong>Legal obligation</strong> – to comply with applicable laws</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Data Sharing and Third Parties</h2>
            <p className="text-gray-700 mb-4">
              <strong>We do not sell your personal data.</strong>
            </p>
            <p className="text-gray-700 mb-4">We use trusted third-party services to operate the App:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Firebase (Google)</strong> – authentication, cloud database, and hosting</li>
              <li><strong>Cloud storage services</strong> – to store inspection data and uploaded files</li>
            </ul>
            <p className="text-gray-700">These providers act as data processors and are contractually required to protect your data and use it only for the purposes we specify.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Data Storage and Security</h2>
            <p className="text-gray-700 mb-4">We take appropriate technical and organisational measures to protect your data:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Encryption in transit (TLS/HTTPS)</li>
              <li>Encryption at rest</li>
              <li>Role-based access controls</li>
              <li>Secure cloud infrastructure</li>
              <li>Regular backups and monitoring</li>
            </ul>
            <p className="text-gray-700">Data is primarily stored in secure data centres within the UK and EU.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Data Retention</h2>
            <p className="text-gray-700 mb-4">We retain data as follows:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Active accounts:</strong> Data is retained while your account remains active</li>
              <li><strong>Deleted accounts:</strong> Data is permanently deleted within 30 days, unless legal retention is required</li>
              <li><strong>Diagnostic logs:</strong> Retained only as long as necessary for troubleshooting</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Your Rights</h2>
            <p className="text-gray-700 mb-4">Under UK GDPR, you have the right to:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Restrict or object to processing</li>
              <li>Request data portability</li>
              <li>Withdraw consent where applicable</li>
            </ul>
            <p className="text-gray-700">You can exercise these rights by contacting us at <a href="mailto:privacy@buildmychecks.co.uk" className="text-primary hover:underline">privacy@buildmychecks.co.uk</a>.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Children's Privacy</h2>
            <p className="text-gray-700">
              Build My Checks is not intended for use by individuals under the age of 13. We do not knowingly collect personal data from children. If you believe a child's data has been collected, please contact us immediately.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">11. International Data Transfers</h2>
            <p className="text-gray-700">
              Where data is transferred outside the UK or EU, we ensure appropriate safeguards are in place, such as Standard Contractual Clauses approved by the relevant authorities.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Changes to This Policy</h2>
            <p className="text-gray-700">
              We may update this Privacy Policy from time to time. Any material changes will be communicated via the App or by email. The "Last updated" date indicates when this policy was last revised.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Contact Us</h2>
            <p className="text-gray-700 mb-4">
              If you have any questions about this Privacy Policy or how we handle your data, please contact us:
            </p>
            <ul className="list-none text-gray-700 space-y-1">
              <li><strong>Privacy & Data Protection:</strong> <a href="mailto:privacy@buildmychecks.co.uk" className="text-primary hover:underline">privacy@buildmychecks.co.uk</a></li>
              <li><strong>Support:</strong> <a href="mailto:support@buildmychecks.co.uk" className="text-primary hover:underline">support@buildmychecks.co.uk</a></li>
              <li><strong>Business Name:</strong> Build My Checks</li>
            </ul>
            <p className="text-gray-700 mt-4">
              You also have the right to lodge a complaint with the UK Information Commissioner's Office (ICO) at:
              <a href="https://ico.org.uk" className="text-primary hover:underline ml-1">https://ico.org.uk</a>
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm text-gray-400">&copy; 2025 Build My Checks. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

// ----------------------------------------------------------------------------------------------
//  Build My Checks (c) 2025 Gareth Morgan - BuildMyChecks.co.uk
//  Solely designed, developed, and maintained by Gareth Morgan.
//  All intellectual property rights reserved.
//  No liability is accepted for unauthorised use, modification, deployment, or maintenance.
// ----------------------------------------------------------------------------------------------
